export default __webpack_public_path__ + "static/media/disk.37a7bafe.svg";